<template>
  <div class="event_header" v-if="eventInfo && eventInfo.NAME">
    <div class="logo" v-if="eventInfo.img">
      <img :src="mediaUrl + eventInfo.img" :alt="eventInfo.NAME">
    </div>
    <div class="event_body">
      <div class="event_title">{{ eventInfo.NAME }}</div>
      <div class="event_desc" v-if="description">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FootballEventHeader',
  props: {
    eventInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mediaUrl: `${window.location.origin}/`,
    };
  },
  computed: {
    description() {
      const text = (this.eventInfo?.PREVIEW_TEXT || '').trim();
      return text;
    },
  },
};
</script>

<style lang="less" scoped>
@import "src/assets/css/variables.less";

.event_header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 12px 0 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: fade(@DarkColorBG, 92%);
  color: @colorText;
  text-align: left;
}

.logo {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  padding: 4px;
  border-radius: 6px;
  background: @colorText;
  .shadow_inset;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.event_body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.event_title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
}

.event_desc {
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.85;
}
</style>
